import React, { useEffect, useState } from 'react';
import { X, Search, Loader2, MessageSquarePlus, Archive, Lock, ChevronRight } from 'lucide-react';
import { api } from '../context/AuthContext';

const Thema = ({ label, sub, onClick, testId, muted }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`w-full flex items-center gap-2 px-3 py-2 text-left text-xs border border-gray-200 hover:border-[#b8893d] hover:bg-[#fbf7f0] transition-colors ${muted ? 'opacity-70' : ''}`}>
    <span className="flex-1 min-w-0 truncate text-[#1B3A5C]">{label}</span>
    {sub && <span className="text-[10px] text-[#7a8a99] truncate">{sub}</span>}
    <ChevronRight className="w-3.5 h-3.5 text-[#b8893d]" />
  </button>
);

const MandantErgebnis = ({ m, offen, onToggle, onWahl }) => (
  <li className="border-b border-gray-100" data-testid={`neuer-chat-mandant-${m.mandanten_nr}`}>
    <button type="button" onClick={onToggle} className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-[#f5f8fa] transition-colors">
      <div className="w-9 h-9 rounded-full bg-[#1B3A5C] text-white font-semibold flex items-center justify-center flex-shrink-0">{m.name.charAt(0).toUpperCase()}</div>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-[#1B3A5C] truncate">{m.name}</p>
        <p className="text-[11px] text-[#7a8a99] font-mono truncate">M-{m.mandanten_nr}{m.email ? ` · ${m.email}` : ''} · {m.akten.length} {m.akten.length === 1 ? 'Akte' : 'Akten'}</p>
      </div>
      {!m.chat_enabled && <Lock className="w-3.5 h-3.5 text-rose-600" title="Chat für Mandant gesperrt" />}
    </button>
    {offen && (
      <div className="px-4 pb-3 space-y-1.5" data-testid={`neuer-chat-themen-${m.mandanten_nr}`}>
        <p className="text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">Chat beginnen in</p>
        <Thema label="Allgemein" sub="Allgemeiner Chat unter der Mandantennummer" onClick={() => onWahl(m, null)} testId={`neuer-chat-allgemein-${m.mandanten_nr}`} />
        {m.akten.map((a) => (
          <Thema key={a.id} label={<>{a.archived && <Archive className="inline w-3 h-3 mr-1" />}{a.aktenzeichen ? `AZ ${a.aktenzeichen}` : 'Akte ohne AZ'}</>} sub={a.rechtsgebiet}
            muted={a.archived} onClick={() => onWahl(m, a)} testId={`neuer-chat-akte-${a.id}`} />
        ))}
      </div>
    )}
  </li>
);

export const NeuerChatDialog = ({ onClose, onWahl }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState(null);
  const [offen, setOffen] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get('/cases/neuer-chat/suche', { params: { q: q.trim() } }).then((r) => {
        setItems(r.data.items || []);
        if ((r.data.items || []).length === 1) setOffen(r.data.items[0].mandanten_nr);
      }).catch(() => setItems([]));
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start sm:items-center justify-center p-4 pt-24 sm:pt-4" onClick={onClose} data-testid="neuer-chat-dialog">
      <div className="bg-white w-full max-w-lg shadow-xl flex flex-col max-h-[80vh]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B3A5C]"><MessageSquarePlus className="w-4 h-4 text-[#b8893d]" /> Neue Nachricht</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="neuer-chat-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <div className="px-4 py-3 border-b border-gray-100">
          <div className="flex items-center gap-2 border border-gray-200 rounded-full px-3 py-2 bg-[#f5f8fa] focus-within:border-[#b8893d]">
            <Search className="w-3.5 h-3.5 text-[#34536b]" />
            <input autoFocus value={q} onChange={(e) => { setQ(e.target.value); setOffen(null); }} placeholder="Mandant suchen: Name, Firma, M-Nr, E-Mail…"
              className="flex-1 text-sm bg-transparent focus:outline-none" data-testid="neuer-chat-search" />
          </div>
        </div>
        <ul className="flex-1 overflow-y-auto min-h-[120px]" data-testid="neuer-chat-liste">
          {items === null && <li className="flex justify-center py-8"><Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" /></li>}
          {items?.length === 0 && <li className="py-8 text-center text-xs text-[#7a8a99]" data-testid="neuer-chat-leer">Kein Mandant mit Mandantennummer gefunden.</li>}
          {items?.map((m) => <MandantErgebnis key={m.mandanten_nr} m={m} offen={offen === m.mandanten_nr} onToggle={() => setOffen(offen === m.mandanten_nr ? null : m.mandanten_nr)} onWahl={onWahl} />)}
        </ul>
      </div>
    </div>
  );
};
